import React, { useState } from 'react';
import './style.less';
import clsx from 'clsx';
import { Popover, Tabs } from 'antd';
import { Icon } from 'shared/components/Icon';
import { TypeIndicator } from 'shared/components/TypeIndicator';
import { OrgProspectPropertyWithMeta } from 'types/user';

const { TabPane } = Tabs;

interface ProspectPropertySelectorProps {
  contactProperties: OrgProspectPropertyWithMeta[];
  companyProperties: OrgProspectPropertyWithMeta[];
  selectedProperty: OrgProspectPropertyWithMeta | undefined;
  onSelect: (selectedProperty: OrgProspectPropertyWithMeta) => void;
}

export const ProspectPropertySelector: React.FC<ProspectPropertySelectorProps> = props => {
  const [open, setOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<
    OrgProspectPropertyWithMeta | undefined
  >(props.selectedProperty);

  return (
    <div className="ProspectPropertySelector">
      <Popover
        trigger={'click'}
        visible={open}
        onVisibleChange={v => {
          setOpen(v);
        }}
        placement="bottomLeft"
        overlayClassName={'ProspectPropertySelector__popover'}
        content={
          <div>
            <Tabs className="ManageProperties__tabs" defaultActiveKey="1">
              <TabPane tab="Contacts" key="1">
                <div className="ProspectPropertySelector__selectablePropertyList">
                  {props.contactProperties?.map(property => {
                    return (
                      <div
                        className="ProspectPropertySelector__selectableProperty"
                        key={property.propertyKey}
                        onClick={() => {
                          setSelectedProperty(property);
                          props.onSelect(property);
                          setOpen(false);
                        }}
                      >
                        <span>{property.label}</span>
                        <div className="ProspectPropertySelector__propertyType">
                          <div
                            className={clsx(
                              'ProspectPropertySelector__propertySourceIndicator',
                              property.isCustom
                                ? 'ProspectPropertySelector__propertySourceIndicator--custom'
                                : '',
                            )}
                          >
                            {property.isCustom ? (
                              <Icon icon="pencil" width={10} height={10} />
                            ) : (
                              <Icon icon="lock2" width={16} height={16} />
                            )}
                          </div>
                          <TypeIndicator type={property.type} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPane>
              <TabPane tab="Companies" key="2">
                <div className="ProspectPropertySelector__selectablePropertyList">
                  {props.companyProperties?.map(property => {
                    return (
                      <div
                        className="ProspectPropertySelector__selectableProperty"
                        key={property.propertyKey}
                        onClick={() => {
                          setSelectedProperty(property);
                          props.onSelect(property);
                          setOpen(false);
                        }}
                      >
                        <span>{property.label}</span>
                        <div className="ProspectPropertySelector__propertyType">
                          <div
                            className={clsx(
                              'ProspectPropertySelector__propertySourceIndicator',
                              property.isCustom
                                ? 'ProspectPropertySelector__propertySourceIndicator--custom'
                                : '',
                            )}
                          >
                            {property.isCustom ? (
                              <Icon icon="pencil" width={10} height={10} />
                            ) : (
                              <Icon icon="lock2" width={16} height={16} />
                            )}
                          </div>
                          <TypeIndicator type={property.type} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPane>
            </Tabs>
          </div>
        }
      >
        <div
          className={clsx(
            'ProspectPropertySelector__trigger',
            open && 'ProspectPropertySelector__trigger--open',
          )}
        >
          {selectedProperty ? (
            <div className="ProspectPropertySelector__selectedProperty">
              <span>{selectedProperty.label}</span>
              <TypeIndicator type={selectedProperty.type} />
            </div>
          ) : (
            <div className="ProspectPropertySelector__placeholder">Select a property</div>
          )}

          <Icon icon="chevron" width={16} height={16} />
        </div>
      </Popover>
    </div>
  );
};
